
      import Good from './good.vue'
      import type { App, Plugin } from 'vue'

      export const GoodPlugin: Plugin = {
        install(app: App) {
          app.component('Good', Good)
        },
      }
      export { Good }
      